import { LazyImport, LazyModule } from 'owa-bundling';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { DictationPluginInterface } from './plugin/DictationPlugin';
import { DictationStore, getDictationStore } from './store/store';
import { default as loadSetDictationLanguageMenu } from './plugin/loadSetDictationLanguageMenu';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "DictationPlugin" */ './lazyIndex')
);

export let LazyDictationPluginClass = createLazyPlugin(
    lazyModule,
    m => m.DictationPlugin,
    'Dictation',
    evt => {
        return false;
    }
);

export const lazyGetDictationLanguagePickerDropDown = new LazyImport(
    lazyModule,
    m => m.getDictationLanguagePickerDropDown
);

export type LazyDictationPlugin = LazyPlugin<DictationPluginInterface>;
export { DictationStore, getDictationStore, loadSetDictationLanguageMenu };
